

define(['squid/index', './directive', './sepaAgreement/route', './sepaMandate/route'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-member-sepa.route', ['squid', 'xo-member-sepa.directive', 'xo-member-sepa.sepaAgreement.route', 'xo-member-sepa.sepaMandate.route']).factory('$MemberSepaRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('MemberSepaRoute', {

            name: 'membersepa',

            directive: 'xo-member-sepa',
            titleContent: 'directDebitAgreement.sepaTitle',

            children: [{
                name: '$XOSepaAgreementRoute',
                attributes: {
                    token: 'token',
                    sepa: 'sepa',
                    'parent-callbacks': 'callbacks'
                }
            }, {
                name: '$XOSepaMandateRoute',
                attributes: {
                    token: 'token',
                    sepa: 'sepa',
                    'parent-callbacks': 'callbacks'
                }
            }]
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/member-sepa/route.js
 ** module id = 433
 ** module chunks = 1
 **/